import styled from 'styled-components'

const Box = styled.div`
  border: 0.5px solid #CCCACD;
  box-sizing: border-box;
  border-radius: 10px;
  margin: 10px;
`

export const NarrowBox = styled(Box)`
  padding: 10px 120px;
`

export const WideBox = styled(Box)`
  padding: 10px 40px;
`
